/**
 * API Client — powered by @seunghan/rails-api-client
 *
 * 기존 import 호환: { api, apiClient } from '@/utils/api'
 */

import { createApiClient } from '@seunghan/rails-api-client';
export type { ApiResponse, ApiError } from '@seunghan/rails-api-client';

const client = createApiClient({
  csrfSelector: 'meta[name="csrf-token"]',
  // ax_admin 전용 에러 핸들러 (필요 시 활성화)
  // onError: (error) => {
  //   if (error.status === 401) window.location.href = '/login';
  // },
});

export const apiClient = client;
export const api = client;

/**
 * FormData 업로드 전용 함수.
 *
 * rails-api-client가 FormData를 JSON.stringify로 변환하는 버그가 있어
 * 파일 업로드 시 fetch를 직접 사용합니다.
 */
export async function uploadFormData<T = unknown>(
  endpoint: string,
  formData: FormData,
  method: 'POST' | 'PATCH' | 'PUT' = 'POST',
): Promise<{ success: boolean; data?: T; errors?: Record<string, string[]>; message?: string }> {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';

  const response = await fetch(endpoint, {
    method,
    body: formData,
    headers: {
      // Content-Type을 명시하지 않아야 브라우저가 multipart/form-data + boundary를 자동 설정함
      'X-CSRF-Token': csrfToken,
    },
  });

  const text = await response.text();
  const json = text ? JSON.parse(text) : {};

  if (!response.ok) {
    return { success: false, errors: json.errors, message: json.message ?? `HTTP ${response.status}` };
  }

  return { success: true, data: json as T };
}
